
// New Help/Contact Modal Component
import { Box, Button, Modal, ModalBody,useColorMode, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, useColorModeValue, VStack } from "@chakra-ui/react";
import React from "react";

const HelpContactModal = ({ isOpen, onClose }) => {
    const bgColor = useColorModeValue("white", "gray.800");
    const borderColor = useColorModeValue("gray.200", "gray.600");
  
    return (
      <Modal isOpen={isOpen} onClose={onClose} size="md">
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(5px)" />
        <ModalContent borderRadius="xl" p={4} bg={bgColor}>
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            bgGradient="linear(to-r, blue.500, teal.500)"
            bgClip="text"
          >
            Help & Contact
          </ModalHeader>
          <ModalBody>
            <VStack spacing={4} align="stretch">
              <Text fontSize="md" color="gray.600">
                We're here to assist you! If you're facing any issues or need help, feel free to reach out to us.
              </Text>
              <Box>
                <Text fontWeight="semibold" color="gray.700">Email:</Text>
                <Text>info@drbillerz.com</Text>
              </Box>
              <Box>
                <Text fontWeight="semibold" color="gray.700">Phone:</Text>
                <Text>+1 (123) 456-7890</Text>
              </Box>
              <Box>
                <Text fontWeight="semibold" color="gray.700">Hours:</Text>
                <Text>Monday - Friday, 9 AM - 5 PM (EST)</Text>
              </Box>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              onClick={onClose}
              size="lg"
              borderRadius="full"
              _hover={{ transform: "translateY(-2px)", shadow: "lg" }}
            >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  };

  export default HelpContactModal;